import React from 'react';
import { Select } from '@gravity-ui/uikit';
import isObjectLike from 'lodash/isObjectLike';
import set from 'lodash/set';
import { Controller, } from '../../../../core';
import { block } from '../../../utils';
import { GroupIndent } from '../../GroupIndent';
import './MultiOneOf.css';
const b = block('multi-oneof');
export const MultiOneOf = (props) => {
    const { name, input, spec, Layout, withoutIndent } = props;
    const { value, onBlur, onChange, onFocus, parentOnUnmount } = input;
    const [valueSelect, setValueSelect] = React.useState(() => (value ? Object.keys(value) : []));
    const handleOpenChange = React.useCallback((open) => {
        if (open) {
            onFocus();
        }
        else {
            onBlur();
        }
    }, [onFocus, onBlur]);
    const parentOnChange = React.useCallback((childName, childValue, childErrors) => {
        onChange((currentValue) => set(Object.assign({}, currentValue), childName.split(`${name}.`).join(''), childValue), childErrors);
    }, [name, onChange]);
    const specProperties = React.useMemo(() => (isObjectLike(spec.properties) ? spec.properties : {}), [spec.properties]);
    const options = React.useMemo(() => (spec.viewSpec.order || Object.keys(specProperties)).map((value) => {
        var _a, _b;
        const title = ((_a = spec.description) === null || _a === void 0 ? void 0 : _a[value]) ||
            ((_b = specProperties[value]) === null || _b === void 0 ? void 0 : _b.viewSpec.layoutTitle) ||
            value ||
            '';
        return {
            value,
            title,
            content: title,
        };
    }), [spec.description, spec.viewSpec.order, specProperties]);
    const filterable = React.useMemo(() => (options.length || 0) > 9, [options.length]);
    const selectInput = React.useMemo(() => {
        const select = (React.createElement(Select, { width: "max", value: valueSelect, options: options, onUpdate: setValueSelect, onOpenChange: handleOpenChange, disabled: spec.viewSpec.disabled, placeholder: spec.viewSpec.placeholder, filterable: filterable, multiple: true, className: b('select'), qa: name }));
        if (Layout) {
            return React.createElement(Layout, Object.assign({}, props), select);
        }
        return React.createElement(React.Fragment, null, select);
    }, [
        Layout,
        filterable,
        handleOpenChange,
        name,
        options,
        props,
        spec.viewSpec.disabled,
        spec.viewSpec.placeholder,
        valueSelect,
    ]);
    if (!options) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        selectInput,
        React.createElement("div", { className: b('content', {
                flat: withoutIndent,
            }) },
            React.createElement(GroupIndent, null, valueSelect.map((property) => {
                var _a;
                return (React.createElement(React.Fragment, { key: property }, specProperties && specProperties[property] ? (React.createElement(Controller, { name: `${name}.${property}`, spec: specProperties[property], parentOnUnmount: parentOnUnmount, parentOnChange: parentOnChange, value: (_a = input.value) === null || _a === void 0 ? void 0 : _a[property] })) : null));
            })))));
};
export const MultiOneOfFlat = (props) => (React.createElement(MultiOneOf, Object.assign({}, props, { withoutIndent: true })));
